import React from 'react'
import { Link } from 'react-router-dom'


const Wrapper = (props) => {
  return (
    <table style={{marginLeft:'auto', marginRight:'auto', width:'786px', marginTop:'14px'}}>
      <tbody>
        <tr>
          <td>

            <table className="BannerBar" >
              <tbody>
                <tr>
                  <td className="BannerBar" width="192" height="84" style={{paddingLeft:'8px'}}>
                    <Link to="/"><img src="/images/cog1.gif" alt="cog" /></Link>
                  </td>
                  <td className="BannerBar" height="84" >cog data systems, llc</td>
                </tr>
              </tbody>
            </table>

            <table className="NavBar" >
              <tbody>
                <tr >
                  <td className="NavBar"><Link to="/" >home</Link></td>
                  <td className="NavBar"><Link to="/services" >services</Link></td>
                  <td className="NavBar"><Link to="/company" >company</Link></td>
                </tr>
              </tbody>
            </table>

            <table className="Main">
              <tbody>
                <tr>
                  <td className="Content" >
                    {props.children}
                  </td>
                </tr>
              </tbody>
            </table>

            <table className="Footer" >
              <tbody>
                <tr >
                  <td><Link className="FooterLink" to="/" >home</Link></td>
                  <td><Link className="FooterLink" to="/services">services</Link></td>
                  <td><Link className="FooterLink" to="/company">company</Link></td>
                </tr>
                <tr >
                  <td colSpan="3" className="Copyright">copyright &copy; 1995 - 2017 cog data systems, llc.  all rights reserved</td>
                </tr>
              </tbody>
            </table>

          </td>
        </tr>
      </tbody>
    </table>
  )
}
export default Wrapper



// WEBPACK FOOTER //
// ./src/components/Wrapper.js